export default __webpack_public_path__ + "static/watermark-55e104746f26b723244fc5384020446e.svg";